<template>
  <div :class="[superpower && superpower.color + '-container']" class="w-full">
    <div class="flex flex-col bg-primary-container text-on-primary-container rounded-medium p-8 relative">
        <span class=" text-body-medium absolute top-5 right-5">{{ useDisplayDate(superpower.date, { dayName: 'none', monthName: 'full', year: 'full' }) }}</span>
      <div class="flex flex-col items-center gap-8 mt-16">
        <div class="relative flex items-center justify-center p-3 h-44 w-44">
          <BaseShapeMask
          shape="12-sided-cookie"
          :scale="1.2"
          class="z-20"
          animation="scale"
          scale-animation-transform="1.15; 1.05; 1.15"
          >
          <img :src="superpower.image" class="scale-120"></img>
        </BaseShapeMask>
        <BaseShape shape="12-sided-cookie" class="absolute z-10 scale-130 text-primary" />
      </div>
        <h3 class="text-display-large font-semibold text-center ">{{ superpower.title }}</h3>
    </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
import type { Skill } from '@/core/models/skill'
import { useDisplayDate } from '../../../core/composables/use-display-date';

interface Props {
  superpower: Skill & {date: string}
}

defineProps<Props>()
</script>
